import { Autocomplete, Box, CircularProgress, IconButton, LinearProgress, Modal, Stack, TextField, Typography } from '@mui/material'
import Grid from "@mui/material/Grid2";
import React, { useEffect, useState } from 'react'
import './styles.scss';
import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined";
import CloseIcon from '@mui/icons-material/Close';
import { PlanningState, useDispatch } from "src/stateManagement/redux";
import { updateTaskStatus } from 'src/stateManagement/redux/slices/planificacion/asynReducer';
import { updatePlanningActivityStatus } from 'src/shared/util/updateDataServer';

const statesList = [
    { label: 'completed', id: 'completed' },
    { label: 'inProgress', id: 'inProgress' },
    { label: 'pending', id: 'pending' },
    { label: 'analyzing', id: 'analyzing' },
    { label: 'discarded', id: 'discarded' },
]


export interface ActivePlanningActivity {
    id: string,
    group: string,
    status: "completed" | "inProgress" | "pending" | "analyzing" | "discarded",
    requirements: any[],
    advance: number,
    currentAdvance: number,
    executedDate: string,
    executedBy: string,
    comments: string,
    numberOfRequirementsPlanned: number,
    numberOfRequirementsExecuted: number,
    executedActivities: number,
    dailyPerformance: number,
    expectedTarget: number,
}


export const UpdateTaskModal = ({ openModal, setOpenModal, plannedActivities, messageSummary, activesSquadData, setInfoAlert, getDailyCloseData }: { openModal: any, setOpenModal: any, plannedActivities: any, messageSummary: any, activesSquadData: any, setInfoAlert: any, getDailyCloseData:any }) => {


    const [loading, setloading] = useState(false)

    const [activePlanningActivity, setActivePlanningActivity] = useState<ActivePlanningActivity | undefined>(undefined)


    useEffect(() => {

        const activePlannedActivities = plannedActivities.find((activity: any) => activity.executedBy === activesSquadData?.name)

        const summaryActivity = messageSummary[activesSquadData?.name]

        if (activePlannedActivities) {

            let advance = activePlannedActivities?.tempFieldAdvance

            if (advance > 100) {
                // advance = 100
            } else if (advance < 0) {
                advance = 0
            }

            let status = activePlannedActivities?.status

            if (advance >= 100) {
                status = "completed"
            } else if (advance > 0) {
                status = "inProgress"
            }

            setActivePlanningActivity({
                id: activePlannedActivities.activityId,
                group: activePlannedActivities?.groupAssigned,
                status,
                requirements: activePlannedActivities?.requirements,
                advance,
                currentAdvance: activePlannedActivities?.advanced,
                executedDate: summaryActivity?.fecha,
                executedBy: activesSquadData?.name,
                comments: activesSquadData?.executedPlanningComment||'',
                numberOfRequirementsPlanned: activePlannedActivities?.plannedActivities,
                numberOfRequirementsExecuted: activePlannedActivities?.executedPlannedActivities,
                executedActivities: activePlannedActivities?.executedFieldActivities,
                dailyPerformance: activePlannedActivities?.tempFieldAdvance,
                expectedTarget: activePlannedActivities?.target
            })
        }

    }, [activesSquadData, plannedActivities, messageSummary])


    const onSaveTask = () => {
        if (activePlanningActivity) {
            setloading(true)
            updatePlanningActivityStatus(activePlanningActivity).then((data) => {
                if (data) {
                    setInfoAlert({ open: true, message: "Actividad actualizada correctamente" })
                    getDailyCloseData()
                    setOpenModal(false)
                }
            }).finally(() => {
                setloading(false)
            }
            )
        }
    }


    const onChange = (value: string, field: string) => {
        if (activePlanningActivity) {
            const newActiveActivity = {
                ...activePlanningActivity,
                [field]: value as keyof ActivePlanningActivity
            }

            if (field === "expectedTarget") {
                const dailyPerformance = Math.ceil((newActiveActivity.numberOfRequirementsExecuted / newActiveActivity.expectedTarget) * 100)
                newActiveActivity.dailyPerformance = dailyPerformance

            }

            setActivePlanningActivity(newActiveActivity)
        }
    }


    return (
        <Modal
            open={openModal}
            onClose={() => setOpenModal(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <>
                {loading && (
                    <>
                        <Box className ="modal_update_planning_task_loading_background"/>
                        <Box className="modal_update_planning_task_loading">
                            {/* <CircularProgress size="8rem" /> */}
                            <LinearProgress />
                            Saving....
                        </Box>
                    </>
                )}
                <Box className="modal_update_planning_task">
                    {/* headers */}
                    <Box className="modal_header">
                        <IconButton
                            aria-label="delete"
                            size='small'
                            onClick={() => setOpenModal(false)}
                            sx={{
                                backgroundColor: "red",
                                color: "#fff",
                                // ml: 2,
                                "&:hover": {
                                    backgroundColor: "#129ED3",
                                },
                            }}
                        >
                            <CloseIcon />
                        </IconButton>
                        <Typography className='title' id="modal-modal-title" variant="h6" component="h2">
                            Actualizar Actividad de Planificacion
                        </Typography>
                        <IconButton
                            aria-label="delete"
                            size='small'
                            onClick={() => onSaveTask()}
                            sx={{
                                backgroundColor: "#03365e",
                                color: "#fff",
                                ml: 2,
                                "&:hover": {
                                    backgroundColor: "#129ED3",
                                },
                            }}
                        >
                            <SaveOutlinedIcon />
                        </IconButton>
                    </Box>
                    {/* linea separator */}
                    <Box
                        component="div"
                        sx={{
                            borderBottom: "3px solid #129ED3",
                            // mt: 1,
                        }}
                    />
                    {/* body */}
                    <Box sx={{ p: 2, gap: 2 }}>
                        <Grid container spacing={2}>
                            <Grid size={6}>
                                <TextField
                                    id="grupo"
                                    label="Grupo"
                                    value={`${activePlanningActivity?.group}`}
                                    disabled={true}
                                    onChange={(e) => { }}
                                    fullWidth
                                    size="small"
                                />
                            </Grid>
                            <Grid size={6}>
                                <TextField
                                    id="requerimientoPlaneado"
                                    label="Requerimientos Planeados"
                                    value={`${activePlanningActivity?.numberOfRequirementsPlanned}`}
                                    disabled={true}
                                    onChange={(e) => { }}
                                    fullWidth
                                    size="small"
                                />
                            </Grid>
                            <Grid size={6}>
                                <TextField
                                    id="requerimientoEjecutado"
                                    label="Requerimiento Ejecutados"
                                    value={`${activePlanningActivity?.numberOfRequirementsExecuted}`}
                                    disabled={true}
                                    onChange={(e) => { }}
                                    fullWidth
                                    size="small"
                                />
                            </Grid>
                            <Grid size={6}>
                                <TextField
                                    id="actividadesEjecutadas"
                                    label="Actividades Ejecutadas"
                                    value={`${activePlanningActivity?.executedActivities}`}
                                    disabled={true}
                                    onChange={(e) => { }}
                                    fullWidth
                                    size="small"
                                />
                            </Grid>
                            <Grid size={6}>
                                <TextField
                                    id="metaEsperada"
                                    label="Meta Esperada"
                                    value={`${activePlanningActivity?.expectedTarget}`}
                                    disabled={false}
                                    onChange={(event) => onChange(event.target.value, "expectedTarget")}
                                    fullWidth
                                    size="small"
                                    type="number"
                                />
                            </Grid>
                            <Grid size={6}>
                                <TextField
                                    id="rendimientoDiario"
                                    label="Rendimiento Diario"
                                    value={`${activePlanningActivity?.dailyPerformance}`}
                                    disabled={true}
                                    onChange={(e) => { }}
                                    fullWidth
                                    size="small"
                                />
                            </Grid>
                            <Grid size={3}>
                                <TextField
                                    id="avanceActual"
                                    label="Avance Actual"
                                    value={`${activePlanningActivity?.currentAdvance}`}
                                    disabled={true}
                                    onChange={(event) => onChange(event.target.value, "currentAdvance")}
                                    fullWidth
                                    size="small"
                                />
                            </Grid>
                            <Grid size={3}>
                                <TextField
                                    id="avanceActual"
                                    label="Nuevo Avance"
                                    value={`${activePlanningActivity?.advance}`}
                                    onChange={(event) => onChange(event.target.value, "advance")}
                                    fullWidth
                                    size="small"
                                />
                            </Grid>
                            <Grid size={6}>
                                <Autocomplete
                                    fullWidth
                                    disablePortal
                                    size="small"
                                    value={statesList.find((state) => state.id === activePlanningActivity?.status) || statesList[0]}
                                    options={statesList}
                                    onChange={(event: any, newValue: any) => onChange(newValue?.id, "status")}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="Nuevo Estado"
                                            fullWidth
                                        />
                                    )}
                                />
                            </Grid>
                            <Grid size={12}>
                                <TextField
                                    id="outlined-multiline-static"
                                    label="Descripción"
                                    multiline
                                    rows={4}
                                    value={`${activePlanningActivity?.comments}`}
                                    onChange={(event) => onChange(event.target.value, "comments")}
                                    fullWidth
                                />
                            </Grid>
                        </Grid>
                    </Box>
                </Box>
            </>
        </Modal>
    )
}